import React from 'react';
import { Route } from 'react-router-dom';
import SPANotFound from '../shared/SPANotFound';
import AlertMessageStatesModal from './AlertMessages/AlertMessageStatesModal';
import { useContentMount } from './contentMount';
import ProgramsPage from './ProgramsPage';
import SPAAddProgramModal from './SPAAddProgramModal';
import SPALicenseAvailabilityModal from './SPALicenseAvailabilityModal';

// AIDEV-NOTE: The Programs page and its routed modals/tabs, shared by ContentView (the SPA) and
// admin/ProgramsPage (the legacy /admin/programs mount). A fragment, which <Routes> flattens.
// ProgramsPage is a layout route — its routed modals render via <Outlet /> under both program tabs;
// /custom-programs, /alert-messages and /reference-materials render the same page on those tabs.
// Anything else under the base is the not-found page (lowest-ranked, so other routes still win).
const programModalRoutes = (
  <>
    <Route element={<SPAAddProgramModal />} path="reuse-program" />
    <Route element={<SPALicenseAvailabilityModal />} path="programs/:programId/licenses" />
  </>
);

// Programs is "/" on the legacy mount and "/content" in the SPA.
const ContentNotFound = () => (
  <SPANotFound homeLabel="Back to Programs" homeTo={useContentMount() === 'legacy' ? '/' : '/content'} />
);

const programsPageRoutes = (
  <>
    <Route element={<ProgramsPage />} path="/">{programModalRoutes}</Route>
    <Route element={<ProgramsPage />} path="/custom-programs">{programModalRoutes}</Route>
    <Route element={<ProgramsPage />} path="/alert-messages">
      <Route element={<AlertMessageStatesModal />} path=":alertMessageId/states" />
    </Route>
    <Route element={<ProgramsPage />} path="/reference-materials" />
    <Route element={<ContentNotFound />} path="*" />
  </>
);

export default programsPageRoutes;
